import { RefObject, useEffect } from 'react'

export default function useOnClickOutside<
  T extends HTMLElement = HTMLDivElement
>(ref: RefObject<T>, handler: (event: Event) => void): void {
  useEffect(() => {
    const listener = (event: Event) => {
      const el = ref?.current
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains((event?.target as Node) || null)) {
        return
      }
      handler(event)
    }
    const escListener = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handler(e)
      }
    }
    document.addEventListener(`mousedown`, listener)
    document.addEventListener(`keydown`, escListener)
    return () => {
      document.removeEventListener(`mousedown`, listener)
      document.removeEventListener(`keydown`, escListener)
    }
    // Reload only if ref or handler changes
  }, [ref, handler])
}